import React__default, { forwardRef } from 'react';
import { useIsMobile, TaktIdProvider, createStormTaktId, Flex } from '@amzn/storm-ui';
import { b as ActionsWrapper, I as InlineError } from '../PageHeader.styles-DxTuQT1k.js';

const ActionsContainer = /*#__PURE__*/forwardRef(({
  errorMessage,
  isWrapped,
  children,
  taktId,
  taktValue
}, ref) => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('page-header-attributes-container')
  }, /*#__PURE__*/React__default.createElement(ActionsWrapper, {
    direction: "column",
    ref: ref,
    isWrapped: isMobile || isWrapped
  }, /*#__PURE__*/React__default.createElement(Flex, {
    wrap: "wrap",
    direction: isMobile ? 'column' : 'row',
    justifyContent: isMobile || isWrapped ? 'flex-start' : 'flex-end',
    alignItems: isMobile ? 'start' : 'center',
    columnGap: isMobile ? 'none' : 'base',
    rowGap: isMobile ? 'small' : 'base'
  }, children), !!errorMessage && /*#__PURE__*/React__default.createElement(InlineError, {
    message: errorMessage,
    variant: "error",
    isRightAligned: !isWrapped
  })));
});

export { ActionsContainer as A };
//# sourceMappingURL=ActionsContainer-DHo_VIiP.js.map
